import { logger } from '@tecma/logs-fe';
import { storeFactory } from 'store';
import { Provider } from 'react-redux';
import { WinstonProvider } from 'winston-react';
import { ProviderGraphQl } from './ProviderGraphQl';
import { ProviderEnvironment } from './ProviderEnvironment';

export const Providers = ({ children }: { children: React.ReactNode }) => {
  const store = storeFactory();
  return (
    <Provider store={store}>
      <ProviderEnvironment>
        <ProviderGraphQl>
          <WinstonProvider logger={logger}>{children}</WinstonProvider>
        </ProviderGraphQl>
      </ProviderEnvironment>
    </Provider>
  );
};
